import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";

import "./Login.css";

import logo from "../../images/logo.png";
import { AuthContext } from "./../../App";

const Login = () => {
    const [[isLoggedIn, setIsLoggedIn], [userType, setUserType]] =
        useContext(AuthContext);

    const [userName, setUserName] = useState(null);
    const [password, setPassword] = useState(null);

    let user = { userType: 0, isLoggedIn: false };
    console.log(user);
    const setLogin = () => {
        if (userName === "admin" && password === "im24@2021") {
            setIsLoggedIn(true);
            setUserType(1);
            user = { userType: 1, isLoggedIn: true };
        } else if (userName === "signmart" && password === "sign@123") {
            setIsLoggedIn(true);
            setUserType(2);
            user = { userType: 2, isLoggedIn: true };
        } else if (userName === "inquiry" && password === "inq@123") {
            setIsLoggedIn(true);
            setUserType(3);
            user = { userType: 3, isLoggedIn: true };
        } else {
            toast.error("enter valid credentials!");
        }
        localStorage.setItem("isLoggedIn", user.isLoggedIn);
        localStorage.setItem("userType", user.userType);
    };

    // useEffect(() => {
    //     user && localStorage.setItem("userData", JSON.stringify(user) )

    // }, [user])

    return (
        <div className="my_card">
            <div className="Heading">
                <img
                    src={logo}
                    alt="logo"
                    className="img-fluid"
                    width={300}
                    height={200}
                />
            </div>
            <div className="card_1">
                <div>
                    <div class="Wrapper">
                        <p className="my_p">Sign in to start your session</p>
                        <label for="inputEmail4" class="form-label"></label>
                        <input
                            type="text"
                            class="form-control my_css"
                            id="userName"
                            placeholder="User name"
                            onChange={(e) => {
                                setUserName(e.target.value);
                            }}
                        />
                    </div>
                    <div class="">
                        <label for="inputPassword4" class="form-label"></label>
                        <input
                            type="password"
                            class="form-control"
                            id="inputPassword4"
                            placeholder="Password"
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />
                    </div>
                    <div class="flex my_css">
                        <div class="">
                            <button
                                type="submit"
                                class="btn btn-primary"
                                onClick={setLogin}
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
